<template>
  <div class="_form">
    <b-row class="m-0">
      <!-- Form-->
      <b-col lg="12" class="d-flex align-items-center px-2 p-lg-5 mt-2">
        <b-col sm="12" md="8" lg="6" class="px-xl-2 mx-auto">
          <b-card>
            <b-card-title class="mb-1 font-weight-bold text-center" title-tag="h2">
              Olá, bem-vindo(a)!
            </b-card-title>
            <b-card-text class="mb-2 text-center" v-if="!generalOrientation">
              Formulário de Intimidação Sistemática<br /><br/>
            </b-card-text>
            <b-card-text class="mb-2" v-if="generalOrientation" v-html-safe="generalOrientation">
            </b-card-text>
            <!-- form -->
            <validation-observer ref="requestForm">
              <b-form class="mb-1 mt-2" @submit.prevent="send">
                <!-- Unity -->
                <b-form-group
                  :label="$t('systematic_intimidation.unit')"
                  label-for="unity">
                    <validation-provider
                      #default="{ errors }"
                     :name="$t('systematic_intimidation.unit')"
                      rules="required">
                      <v-select v-model="legalEntity" :options="listLegal" label="name" class="required-select" ref="select-legal-entity">
                        <div slot="no-options">{{$t('msg_none')}}</div>
                      </v-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
                <!-- Link -->
                <b-form-group :label="$t('systematic_intimidation.link_profile')" label-for="link_profile">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('systematic_intimidation.link_profile')">
                    <b-form-input
                      id="link_profile"
                      v-model="linkProfile"
                      name="linkProfile"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- Description -->
                <b-form-group
                  :label="$t('systematic_intimidation.description')"
                  label-for="description">
                  <b-form-textarea
                    id="description"
                    v-model="description"
                    :state="description.length >= 10"
                    :placeholder="$t('form_min_caracter')"
                    rows="4"></b-form-textarea>
                  </b-form-group>

                <!-- submit buttons -->
                <div class="vx-row pt-2">
                  <div class="vx-col w-full">
                      <b-button
                        type="submit"
                        variant="primary"
                        class="waves-effect float-right">
                        Enviar
                        <!--:disabled="!validateForm"-->
                      </b-button>
                  </div>
                </div>
              </b-form>
            </validation-observer>
            <!-- end form-->
            <b-card-footer class="text-right">
              <small class="text-muted">Desenvolvido por:</small> &nbsp;&nbsp;
              <b-link href="https://securamdata.com" target="_brank">securamdata.com</b-link>
            </b-card-footer>
          </b-card>
        </b-col> <!-- b-col-->
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormTextarea,
  BCard,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import vSelect from 'vue-select'
import Datepicker from 'educatena-vuejs-datepicker'
import { ptBR } from 'educatena-vuejs-datepicker/dist/locale'
import standard from '@/services/standard'


import SystematicIntimidationFormService from '@/services/api/intimidation/SystematicIntimidationFormService'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BCard,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BForm,
    BButton,
    BAlert,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    Datepicker,
  },
  props: {
    param_encrypt: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      format: 'dd/MM/yyyy',
      ptBR,
      legalEntity: '',
      description: '',
      linkProfile: '',
      generalOrientation: '',
      legalEntityList : [],
      // validation rules
      required,
      email,
      services: {
        form : null,
      }
    }
  },
  watch: {

  },
  computed: {
    validateForm() {
      return (
        !this.isEmpty(this.legalEntity)
      )
    },
    listLegal(){
       this.legalEntityList.push({
        id: null,
        name: "Outras",
        trading_name: "Outras"
      })
      return this.legalEntityList
    }
  },
  methods: {
    fileAdded(file){
      //console.log(file)
      //this.fileUpload = file;
    },
    error(...a) {
      console.log('error: ', ...a)
    },
    added(...a) {
      console.log('added: ', ...a)
    },
    send() {
      this.$refs.requestForm.validate().then(success => {
        if (success) {
          this.$vs.loading()
          this.clearErrors(this.$refs.requestForm)
          this.sendForm();
        }else{
          console.log('error!', success)
          this.errorAlertFormValidaded()
        }
      },
      error => {
        console.log('error: ', error)
      })
    },
    sendForm(){
      const params = this.getDataFields()
      this.services.form.createOrUpdate(params).then(
        data => {
          this.$vs.loading.close()
          this.sucessAlertPrococol(data)
        },
        error => {
          this.$vs.loading.close()
          this.notifyError(this.$vs, 'Não foi possível enviar esse formulário.', 3000)
        }
      )
    },
    successSend(data){
      this.notifySuccess(this.$vs, 'Formulário enviado com sucesso!', 3000)
      this.$vs.loading.close()
      this.clearFields()
    },
    sucessAlertPrococol(data){
      //this.notifySuccess(this.$vs, 'Formulário enviado com sucesso!', 3000)
      let msg = `Suas informações foram registradas com sucesso! Protocolo gerado: ${data.protocol_number}`

      this.$vs.dialog({
        type: 'alert',
        color: 'success',
        title: 'Procotolo',
        acceptText: 'ok',
        text: msg,
        accept: this.clearFields,
      })
    },
    getDataFields(){
      const params = {
              legal_entity_id: _.get(this.legalEntity,'id'),
              description: this.description,
              link: this.linkProfile,
              data_encrypt: this.param_encrypt, //Get from URl
          }
      return params;
    },
    clearFields() {
      this.legalEntity = '',
      this.description = '',
      this.linkProfile = '',
      this.$nextTick( () => {this.clearErrors(this.$validator)})

    },
    errorAlertFormValidaded(){
      const firstField = this.$el.querySelector('.is-invalid')
      if(firstField){
        firstField.scrollIntoView()
      }
      this.notifyWarning(this.$vs, 'Preencha corretamente os campos do formulário!', 3000)
    },
  },
  mounted() {
    //console.log(this.param_encrypt)
  },
  beforeMount() {
    this.$vs.loading()
    const promisses = []

    //Services
    this.services.form = SystematicIntimidationFormService.build(this.$vs)

    promisses.push(
      this.services.form.getListLegalEntity(this.param_encrypt).then(
        data => {
          this.legalEntityList = data.list
          this.generalOrientation = data.header
        },
        error => {

        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    )

    Promise.all(promisses).then(() => {
      this.$vs.loading.close()
    })

  }
}
</script>

<style lang="scss" scoped>
</style>

